export default "__VITE_ASSET__PiNR7lmf__"